// APIのURL
export const API_BASE_URL = process.env.REACT_APP_API_URL as string;

// APIキー
export const API_KEY = process.env.REACT_APP_API_KEY as string;

export const API_URL = process.env.REACT_APP_API_URL as string;

/** 未設定・空・不正値のときは 1.1（`REACT_APP_TAX_RATE` を .env で上書き可能） */
const DEFAULT_TAX_RATE = 1.1;

function readTaxRateFromEnv(): number {
  const raw = process.env.REACT_APP_TAX_RATE;
  if (raw === undefined || raw === "") {
    return DEFAULT_TAX_RATE;
  }
  const n = Number.parseFloat(String(raw).trim());
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_TAX_RATE;
}

export const TAX_RATE = readTaxRateFromEnv();

// test用
// export const API_URL = "http://localhost:8081";
